import { DevelopusTreeTableType } from '../../../common/ui/treetable/DevelopusTreeTable'
import DevelopusTreeTableBodyUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableBodyUIModel'
import DevelopusTreeTableCellUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableCellUIModel'
import DevelopusTreeTableCellsUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableCellsUIModel'
import DevelopusTreeTableHeadUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableHeadUIModel'
import DevelopusTreeTableUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableUIModel'
import { StudentUI, getStudentTreeTable } from './StudentUI'

export type StudentsUI = {
  students: StudentUI[]
}

export const getStudentsTreeTable = (
  studentsUI: StudentsUI,
): DevelopusTreeTableType => {
  const tableHead = new DevelopusTreeTableHeadUIModel(
    new DevelopusTreeTableCellsUIModel([
      new DevelopusTreeTableCellUIModel('users.info.firstName'),
      new DevelopusTreeTableCellUIModel('users.info.lastName'),
      new DevelopusTreeTableCellUIModel('users.common.license'),
      new DevelopusTreeTableCellUIModel('users.common.cost'),
      new DevelopusTreeTableCellUIModel('users.common.paid'),
    ]),
  )

  const tableBody = new DevelopusTreeTableBodyUIModel(
    studentsUI.students.map((student: StudentUI) =>
      getStudentTreeTable(student),
    ),
  )

  const table = new DevelopusTreeTableUIModel(
    'students-table',
    tableHead,
    tableBody,
  )

  return table.toUI()
}
